// console.log(`js/01-pageSections/schedule.js is working`);

let schedules = document.querySelectorAll(`.page-section-schedule`);

if (schedules) {
  schedules.forEach((schedule) => {
    let programs = schedule.querySelectorAll(`.program-name`);
    let courses = schedule.querySelectorAll(`.class > .program-abbreviation`);
    let classCells = schedule.querySelectorAll(`.class`);
    let showAll = schedule.querySelector(`.show-all`);
    let rowList = schedule.querySelectorAll(`.time-slot`);
    let colNum;
    let eachCell = schedule.querySelectorAll(`.schedule-container > div`);

    if (schedule) {
      colNum = schedule.querySelector(`.schedule-container`).dataset.colnum;
      clean(schedule);
      programs.forEach((program) => {
        program.addEventListener(`click`, removeProgram);
      });
      showAll.addEventListener(`click`, showAllProgram);
      colorRows();
      numberEachCell();
    }

    function numberEachCell() {
      let number = 1;
      let columnNumbers = parseInt(colNum) + 1;
      eachCell.forEach((cell) => {
        if (number % columnNumbers === 0) {
          cell.style.borderRight = `none`;
          cell.style.borderTopRightRadius = `var(--borderRadius)`;
          cell.style.borderBottomRightRadius = `var(--borderRadius)`;
        }
        number++;
      });
    }

    function removeProgram() {
      showAllProgram();
      let className = this.classList[1];
      let classCellChildrenStatus = [];
      classCells.forEach((classCell) => {
        let classCellChildren = classCell.childNodes;
        if (classCellChildren.length === 0) {
          classCell.dataset.currentState = `empty`;
          classCellChildrenStatus.push(`empty`);
        } else {
          classCellChildrenArray = [];
          classCellChildren.forEach((classCellChild) => {
            if (classCellChild.classList.contains(className)) {
              classCellChild.classList.add(`grow-class`);
              classCellChild.classList.remove(`shrink-class`);
              classCellChildrenArray.push(`full`);
            } else {
              classCellChild.classList.add(`shrink-class`);
              classCellChild.classList.remove(`grow-class`);
              classCellChildrenArray.push(`empty`);
            }
          });
          if (classCellChildrenArray.includes(`full`)) {
            classCellChildrenStatus.push(`full`);
          } else {
            classCellChildrenStatus.push(`empty`);
          }
        }
      });
      checkRow(classCellChildrenStatus);
    }

    function showAllProgram() {
      courses.forEach((course) => {
        course.classList.add(`grow-class`);
      });
      classCells.forEach((classCell) => {
        classCell.classList.add(`grow-cell`);
        classCell.classList.remove(`shrink-cell`);
      });
      rowList.forEach((rowListTime) => {
        rowListTime.classList.add(`grow-cell`);
        rowListTime.classList.remove(`shrink-cell`);
        rowListTime.firstChild.style.display = ``;
      });
      colorRows();
    }

    function checkRow(classesArray) {
      let rowsArray = [];
      let i = 0;

      while (classesArray.length > 0) {
        let checkRow = classesArray.splice(0, colNum);
        rowsArray.push(checkRow);
      }

      rowsArray.forEach((row) => {
        if (!row.includes(`full`)) {
          rowList[i].classList.toggle(`grow-cell`);
          rowList[i].classList.toggle(`shrink-cell`);
          rowList[i].firstChild.style.display = `none`;
        }
        i++;
      });
      emptyRows();
      colorRows();
    }

    function colorRows() {
      let updatedRowList = schedule.querySelectorAll(`.time-slot`);
      let k = 0;
      updatedRowList.forEach((updatedRow) => {
        updatedRow.style.borderTopLeftRadius = `var(--borderRadius)`;
        updatedRow.style.borderBottomLeftRadius = `var(--borderRadius)`;
        if (updatedRow.classList.contains(`grow-cell`)) {
          let j = updatedRow;
          if (k % 2 === 0) {
            for (l = 0; l <= colNum; l++) {
              j.style.backgroundColor = `var(--body-background)`;
              j = j.nextElementSibling;
            }
          } else if (k % 2 === 1) {
            for (l = 0; l <= colNum; l++) {
              j.style.backgroundColor = `var(--body-background-darkened)`;
              j = j.nextElementSibling;
            }
          }
          k++;
        }
      });
    }

    function emptyRows() {
      let updatedRowList = schedule.querySelectorAll(`.time-slot`);
      for (i = 0; i < updatedRowList.length; i++) {
        if (updatedRowList[i].classList.contains(`shrink-cell`)) {
          let k = updatedRowList[i].nextElementSibling;

          for (j = 0; j < colNum; j++) {
            k.classList.toggle(`grow-cell`);
            k.classList.toggle(`shrink-cell`);
            k = k.nextElementSibling;
          }
        }
      }
    }

    function clean(node) {
      for (var n = 0; n < node.childNodes.length; n++) {
        var child = node.childNodes[n];
        if (
          child.nodeType === 8 ||
          (child.nodeType === 3 && !/\S/.test(child.nodeValue))
        ) {
          node.removeChild(child);
          n--;
        } else if (child.nodeType === 1) {
          clean(child);
        }
      }
    }
  });
}
